import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../contexts/PermissionContext';

const PermissionGuard = ({ 
  children, 
  permission, 
  module, 
  anyPermission,
  fallback = null 
}) => {
  const { dashboardUser } = useAuth();
  const { hasPermission, hasModule, hasAnyPermission, loading } = usePermissions();

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Admin has access to everything
  if (dashboardUser?.role === 'admin') {
    return children;
  }

  // Check permissions for employees
  let hasAccess = false;

  if (module) {
    hasAccess = hasModule(module);
  } else if (anyPermission && Array.isArray(anyPermission)) {
    hasAccess = hasAnyPermission(anyPermission);
  } else if (permission) {
    hasAccess = hasPermission(permission);
  } else {
    // No specific permission required
    hasAccess = true;
  }

  if (!hasAccess) {
    return fallback || (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-gray-500">
            Contact your administrator to request access.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default PermissionGuard;
